import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Paper, Switch, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { RangePlanningItem } from '../types';
import useRangePlanningItemsApi from '../hooks/useRangePlanningItemsApi';

interface CatalogueAvailabilityTabProps {
  item: RangePlanningItem;
}

const CatalogueAvailabilityTab = ({ item }: CatalogueAvailabilityTabProps) => {
  const { t } = useTranslation('rangePlanningItems');
  const { toggleCatalogueAvailability } = useRangePlanningItemsApi();
  const [availability, setAvailability] = useState(item.catalogueAvailability);

  const handleToggle = async (catalogueName: string, available: boolean) => {
    setAvailability((prev) => prev.map((c) => (c.catalogueName === catalogueName ? { ...c, available } : c)));
    await toggleCatalogueAvailability(item.id, catalogueName, available);
  };

  if (availability.length === 0) {
    return (
      <Paper variant="outlined"
        sx={{ p: 4, textAlign: 'center' }}>
        <Typography color="text.secondary">
          {t('noCatalogueAvailability', 'This item is not assigned to any catalogue yet.')}
        </Typography>
      </Paper>
    );
  }

  return (
    <Paper variant="outlined">
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>{t('catalogueName', 'Catalogue')}</TableCell>
            <TableCell align="right">{t('available', 'Available')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {availability.map((entry) => (
            <TableRow key={entry.catalogueName}>
              <TableCell>{entry.catalogueName}</TableCell>
              <TableCell align="right">
                <Switch
                  checked={entry.available}
                  onChange={(e) => handleToggle(entry.catalogueName, e.target.checked)}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default CatalogueAvailabilityTab;
